<template>
  <div
    class="relative w-full h-full overflow-hidden"
    @mouseenter="stopAutoPlay"
    @mouseleave="startAutoPlay"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
  >
    <transition-group name="fade" tag="div">
      <div
        v-for="(slide, index) in slides"
        :key="slide.id"
        v-show="index === currentIndex"
        class="absolute inset-0 w-full h-full"
      >
        <a href="#" class="block w-full h-full group">
          <img
            :src="slide.image"
            :alt="'Slide ' + slide.id"
            class="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
          />
        </a>

        <div
          class="absolute inset-0 flex flex-col items-center justify-start pt-32 md:pt-48 text-center text-white pointer-events-none"
        >
          <a
            :href="slide.link"
            class="pointer-events-auto bg-white text-black px-8 py-3 rounded-full text-sm font-bold hover:bg-black hover:text-white transition-colors duration-300"
          >
            {{ slide.cta }}
          </a>
        </div>
      </div>
    </transition-group>

    <button
      class="absolute left-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/30 text-white rounded-full flex items-center justify-center hover:bg-black/60 transition z-10"
      @click="prevSlide"
    >
      &lt;
    </button>
    <button
      class="absolute right-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/30 text-white rounded-full flex items-center justify-center hover:bg-black/60 transition z-10"
      @click="nextSlide"
    >
      &gt;
    </button>

    <div
      class="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 z-10"
    >
      <div
        v-for="(slide, index) in slides"
        :key="'dot-' + slide.id"
        class="w-3 h-3 rounded-full cursor-pointer transition-colors duration-300"
        :class="
          index === currentIndex ? 'bg-white' : 'bg-white/50 hover:bg-white/80'
        "
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroCarousel",
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      autoplayInterval: 5000, // 自动播放间隔 5 秒
      touchStartX: 0,
      touchEndX: 0,
      minSwipeDistance: 50, // 最小滑动距离（像素）
      slides: [
        {
          id: 1,
          image:
            "http://img-for-hk.wds168.cn/comdata/6482285/201910/201910121409071b6767.jpg",
          link: "#",
        },
        {
          id: 2,
          image:
            "http://img-for-hk.wds168.cn/comdata/6482285/201910/2019101113545312175a.jpg",
          link: "#",
        },
        {
          id: 3,
          image:
            "http://img-for-hk.wds168.cn/comdata/6482285/201910/20191012140846dda561.jpg",
          link: "#",
        },
      ],
    };
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeUnmount() {
    this.stopAutoPlay();
  },
  methods: {
    // 启动自动播放
    startAutoPlay() {
      if (this.slides.length > 1 && !this.intervalId) {
        this.intervalId = setInterval(this.nextSlide, this.autoplayInterval);
      }
    },
    // 停止自动播放
    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    // 切换到下一张
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    // 切换到上一张
    prevSlide() {
      const newIndex = this.currentIndex - 1;
      this.currentIndex = newIndex < 0 ? this.slides.length - 1 : newIndex;
    },
    // 切换到指定指示点
    goToSlide(index) {
      this.currentIndex = index;
      this.stopAutoPlay();
      this.startAutoPlay(); // 切换后重新计时
    },
    // 触摸开始
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.stopAutoPlay();
    },
    // 触摸移动
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    },
    // 触摸结束
    handleTouchEnd() {
      const swipeDistance = this.touchStartX - this.touchEndX;

      // 向左滑动（显示下一张）
      if (swipeDistance > this.minSwipeDistance) {
        this.nextSlide();
      }
      // 向右滑动（显示上一张）
      else if (swipeDistance < -this.minSwipeDistance) {
        this.prevSlide();
      }

      // 重新启动自动播放
      this.startAutoPlay();

      // 重置触摸位置
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
  },
};
</script>

<style scoped>
/* 使用 Vue 的过渡动画实现淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 确保离开的元素不影响进入的元素，否则会出现堆叠效果 */
.fade-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
